export const phoneNumberFetcher = (randomFactor: number) => {
	// const numbers = [
	// 	"(11) 93225-5666",
	// "(11) 93228-9861",
	// "(11) 97626-2740",
	// "(11) 96610-3344",
	// "(11) 98896-2064",
	// "(11) 98896-8524",
	// 	"(11) 98896-5449",
	// 	"(11) 98895-9404",
	// ];

	// return numbers[Math.floor(randomFactor * numbers.length)];
	return "11997093532";
};
